function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import window from './windowWrapper';
import { baseUtils } from '../utils/baseUtils';

var ExperimentsWrapper = /*#__PURE__*/function () {
  function ExperimentsWrapper() {
    this.getExperiment = this.getExperiment.bind(this);
    this.getExperiments = this.getExperiments.bind(this);
    this.setExperiments = this.setExperiments.bind(this);
    this.getExperimentBoolean = this.getExperimentBoolean.bind(this);
    this._experiments = Object.assign({}, _objectSpread({}, window.petri));
    this.experimentsAreReady = Object.keys(this._experiments) > 0;
    this.onExperimentReadyCb = [];
  }

  var _proto = ExperimentsWrapper.prototype;

  _proto.setExperiments = function setExperiments(_experiments) {
    if (!_experiments) {
      return;
    }

    try {
      Object.assign(this._experiments, _objectSpread({}, _experiments));

      if (baseUtils.isDev()) {
        window.petri = this._experiments;
      }

      this.triggerExperimentsReady(); // resolve the promise

      this.experimentsAreReady = true;
    } catch (e) {
      console.error('Could not set experiments', e);
    }
  };

  _proto.getExperiments = function getExperiments() {
    // todo - this is a temp fix for development
    if (baseUtils.isDev()) {
      return _objectSpread(_objectSpread({}, this._experiments), window.petri);
    }

    return this._experiments;
  };

  _proto.getExperiment = function getExperiment(experiment) {
    return this.experiments[experiment];
  };

  _proto.getExperimentBoolean = function getExperimentBoolean(experiment) {
    return this.getExperiment(experiment) === 'true' || this.getExperiment(experiment) === true;
  };

  _proto.triggerExperimentsReady = function triggerExperimentsReady() {
    var _this = this;

    try {
      this.onExperimentReadyCb.forEach(function (cb) {
        return cb(_this.experiments);
      });
    } catch (e) {
      console.error('Could not trigger experiments callback', e);
    }
  };

  _proto.onExperimentsReady = function onExperimentsReady(callback) {
    if (typeof callback === 'function') {
      if (this.isReady) {
        callback(this.experiments);
      } else {
        this.onExperimentReadyCb.push(callback);
      }
    }
  };

  _createClass(ExperimentsWrapper, [{
    key: "experiments",
    get: function get() {
      return this.getExperiments();
    }
  }, {
    key: "isReady",
    get: function get() {
      return this.experimentsAreReady || Object.keys(this._experiments) > 0;
    }
  }]);

  return ExperimentsWrapper;
}();

var getExperimentsWrapper = function getExperimentsWrapper() {
  if (baseUtils.isDev()) {
    if (!window.proGalleryExperimentsWrapper) {
      var _experimentsWrapper = new ExperimentsWrapper();

      window.proGalleryExperimentsWrapper = _experimentsWrapper;
    }

    return window.proGalleryExperimentsWrapper;
  }

  return new ExperimentsWrapper();
};

var experimentsWrapper = getExperimentsWrapper();
export default experimentsWrapper.getExperiment;
export { experimentsWrapper };